// @ts-nocheck
import { Component } from '@theme/component';

function whenSwiperReady(callback) {
  if (typeof window.whenSwiperReady === 'function') {
    return window.whenSwiperReady(callback);
  }
  if (window.Swiper) {
    callback(window.Swiper);
    return Promise.resolve();
  }
  return Promise.resolve();
}

class HeroSlider extends Component {
  constructor() {
    super();
    this.swiperInstance = null;
  }
  connectedCallback() {
    const isHomepage = document.body?.getAttribute('templ') === 'index';
    if (!isHomepage) {
      this.style.opacity = '0';
      this.style.transition = 'opacity 0.4s ease-in-out';
    }
    setTimeout(() => this.initSwiper(), 50);
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
  }

  initSwiper() {
    if (this.swiperInstance) return;

    const optionsAttr = this.getAttribute('carousel-options');
    let customOptions = {};

    if (optionsAttr) {
      try {
        customOptions = JSON.parse(optionsAttr);
      } catch (e) {
        console.warn('HeroSlider: Invalid JSON options', e);
      }
    }

    const navNext = this.querySelector('.heroSlideshow__nav--next');
    const navPrev = this.querySelector('.heroSlideshow__nav--prev');
    const paginationEl = this.querySelector('.heroSlideshow__pagination');

    const finalOptions = {
      ...customOptions,
      resistanceRatio: 0.7,
      watchSlidesProgress: true,
      grabCursor: true,
      a11y: {
        enabled: true,
        ...(customOptions.a11y || {}),
        slideRole: null,
      },
      navigation: {
        nextEl: navNext,
        prevEl: navPrev,
        ...(customOptions.navigation || {})
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        ...(customOptions.pagination || {})
      },
      on: {
        init: () => {
          this.style.opacity = '1';
          this.querySelectorAll('a.swiper-slide[role="group"]').forEach((slide) => {
            slide.removeAttribute('role');
          });
        },
        touchStart: function() {
          const swiper = this;
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
          }
        }
      }
    };

    whenSwiperReady((SwiperLib) => {
      if (this.swiperInstance) return;
      this.classList.add('swiper');
      this.swiperInstance = new SwiperLib(this, finalOptions);
    }).catch(() => {
      this.style.opacity = '1';
    });
  }
}

if (!customElements.get('hero-slider')) {
  customElements.define('hero-slider', HeroSlider);
}
class CountdownTimer extends Component {
  constructor() {
    super();
    this.timerInterval = null;
  }

  connectedCallback() {
    const endsAt = this.getAttribute('countdown-timer-ends');
    if (!endsAt) return;
    this.innerHTML = `
        <div class="countdownTimer">
          ${this.renderUnit('days')}
          ${this.renderUnit('hours')}
          ${this.renderUnit('minutes')}
          ${this.renderUnit('seconds')}
        </div>
      `;
    this.elements = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]')
    };

    this.targetDate = new Date(endsAt).getTime();
    this.updateTimer();
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  disconnectedCallback() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  renderUnit(unit) {
    return `
        <span class="countdownTimer__increment">
          <span class="countdownTimer__incrementValue" data-unit="${unit}">0</span>
          <span class="countdownTimer__incrementUnit">${unit}</span>
        </span>
      `;
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.targetDate - now;

    if (distance < 0) {
      clearInterval(this.timerInterval);
      this.innerHTML = "";
      const parentBar = this.closest('.countdownBar');
      if (parentBar) parentBar.style.display = 'none';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.elements.days) this.elements.days.textContent = days;
    if (this.elements.hours) this.elements.hours.textContent = hours;
    if (this.elements.minutes) this.elements.minutes.textContent = minutes;
    if (this.elements.seconds) this.elements.seconds.textContent = seconds;
  }
}
customElements.define('countdown-timer', CountdownTimer);

class ContentSwiper extends Component {
  constructor() {
    super();
    this.swiperInstance = null;
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.style.opacity = '0';
    this.style.transition = 'opacity 0.4s ease-in-out';
    requestAnimationFrame(() => {
      this.initSwiper();
    });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initSwiper() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) {
      this.style.opacity = '1';
      return;
    }

    let options;
    try {
      options = JSON.parse(swiperEl.getAttribute('carousel-options'));
    } catch (e) {
      this.style.opacity = '1';
      return;
    }

    const alignSelector = swiperEl.getAttribute('carousel-offset-with');
    const alignElement = alignSelector ? document.querySelector(alignSelector) : null;

    const getPadding = () => {
      if (alignElement) {
        const rect = alignElement.getBoundingClientRect();
        return rect.left > 0 ? rect.left : 20;
      }
      return 20;
    };

    const initParams = {
      ...options,
      slidesOffsetBefore: getPadding(),
      slidesOffsetAfter: getPadding(),
      scrollbar: {
        el: options.scrollbar?.el || this.querySelector('.swiper-scroll__scrollbar'),
        draggable: true
      },
      on: {
        init: () => {
          this.style.opacity = '1';
        },
        resize: function () {
          const newPadding = getPadding();
          this.params.slidesOffsetBefore = newPadding;
          this.params.slidesOffsetAfter = newPadding;
          this.update();
        }
      }
    };

    whenSwiperReady((Swiper) => {
      if (this.swiperInstance) return;
      this.swiperInstance = new Swiper(swiperEl, initParams);
    });
  }
}
customElements.define('content-swiper', ContentSwiper);

class CollectionSwiper extends Component {
  constructor() {
    super();
    this.swiperInstance = null;
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.style.opacity = '0';
    this.style.transition = 'opacity 0.4s ease-in-out';
    requestAnimationFrame(() => {
      this.initSwiper();
    });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initSwiper() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) {
      this.style.opacity = '1';
      return;
    }

    let options;
    try {
      options = JSON.parse(swiperEl.getAttribute('carousel-options'));
    } catch (e) {
      this.style.opacity = '1';
      return;
    }

    const alignSelector = swiperEl.getAttribute('carousel-offset-with');
    const alignElement = alignSelector ? document.querySelector(alignSelector) : null;

    const getPadding = () => {
      if (alignElement) {
        const rect = alignElement.getBoundingClientRect();
        return rect.left > 0 ? rect.left : 20;
      }
      return 20;
    };

    const initParams = {
      ...options,
      slidesOffsetBefore: getPadding(),
      slidesOffsetAfter: getPadding(),
      scrollbar: {
        el: options.scrollbar?.el || this.querySelector('.swiper-scroll__scrollbar'),
        draggable: true
      },
      on: {
        init: () => {
          this.style.opacity = '1';
        },
        resize: function () {
          const newPadding = getPadding();
          this.params.slidesOffsetBefore = newPadding;
          this.params.slidesOffsetAfter = newPadding;
          this.update();
        }
      }
    };

    whenSwiperReady((Swiper) => {
      if (this.swiperInstance) return;
      this.swiperInstance = new Swiper(swiperEl, initParams);
    });
  }
}
customElements.define('collection-swiper', CollectionSwiper);

class ProductSwiper extends Component {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    // Check which type of swiper this is
    if (this.hasAttribute('recommended-products')) {
      this.fetchRecommendations();
    } else if (this.hasAttribute('recently-viewed')) {
      this.fetchRecentlyViewed();
    } else {
      this.initSwiper();
    }

    window.addEventListener('resize', this.handleResize.bind(this));
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  // --- Fetch Recommended Products ---
  fetchRecommendations() {
    const url = this.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.swiper-wrapper');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.querySelector('.swiper-wrapper').innerHTML = recommendations.innerHTML;
          this.initSwiper();
        } else {
          this.hideSection();
        }
      })
      .catch(e => {
        console.error('Recommendations fetch error:', e);
        this.hideSection();
      });
  }
  // --- Fetch Recently Viewed Products ---
  async fetchRecentlyViewed() {
    const currentProductEl = document.querySelector('product-swiper[recently-viewed]');
    const currentProductId = currentProductEl ? currentProductEl.getAttribute('product-id') : null;
    let items = [];
    try {
      items = JSON.parse(localStorage.getItem('recently_viewed_products') || '[]');
      if (currentProductId) {
        items = [currentProductId, ...items.filter(id => id !== currentProductId)];
      }
      items = items.slice(0, 20);
      localStorage.setItem('recently_viewed_products', JSON.stringify(items));
    } catch (err) {
      console.warn('RecentlyViewed: Cannot access localStorage', err);
    }
    const filteredItems = items.filter((id) => id !== currentProductId);
    // console.log(filteredItems)
    if (filteredItems.length === 0) {
      this.hideSection();
      return;
    }
    const queryString = filteredItems.slice(0, 8).map((id) => `id:${id}`).join(' OR ');
    const routesRoot = window.theme?.routes?.root || '/';
    try {
      const res = await fetch(`${routesRoot}search?view=cards&type=product&q=${queryString}`);
      const data = (await res.text()).trim();
      if (res.ok && data !== '') {
        const swiperWrapper = this.querySelector('.swiper-wrapper');
        if (swiperWrapper) {
          swiperWrapper.innerHTML = data;
          this.initSwiper();
        }
      } else {
        this.hideSection();
      }
    } catch (error) {
      console.error('RecentlyViewed: Error fetching products:', error);
      this.hideSection();
    }
  }

  hideSection() {
    const sectionModule = this.closest('.sectionModule');
    if (sectionModule) sectionModule.style.display = 'none';
    this.style.display = 'none';
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.swiper');
    const swiperWrapper = this.querySelector('.swiper-wrapper');
    const sectionModule = this.closest('.sectionModule');
    const slides = swiperWrapper ? swiperWrapper.querySelectorAll('.swiper-slide') : [];

    if (slides.length === 0) {
      this.hideSection();
      return;
    } else {
      if (sectionModule) sectionModule.style.display = 'block';
    }

    if (!swiperContainer) return;
    const offset = this.calcOffset();
    let options = this.getOptions();

    const finalConfig = {
      ...options,
      observer: true,
      observeParents: true,
      slidesOffsetBefore: offset,
      slidesOffsetAfter: offset,
      scrollbar: {
        el: this.querySelector('.swiper-scroll__scrollbar'),
        draggable: true,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-nav--next'),
        prevEl: this.querySelector('.swiper-nav--prev'),
      },
    };
    whenSwiperReady((Swiper) => {
      if (this.swiperInstance) return;
      this.swiperInstance = new Swiper(swiperContainer, finalConfig);
    });
  }

  calcOffset() {
    const wrapper = this.querySelector('.wrapper') || document.querySelector('.wrapper');
    if (wrapper) {
      const rectLeft = wrapper.getBoundingClientRect().left;
      const style = window.getComputedStyle(wrapper);
      const paddingLeft = parseFloat(style.paddingLeft) || 0;
      return rectLeft + paddingLeft;
    }
    return 0;
  }

  handleResize() {
    if (this.swiperInstance) {
      const newOffset = this.calcOffset();
      this.swiperInstance.params.slidesOffsetBefore = newOffset;
      this.swiperInstance.params.slidesOffsetAfter = newOffset;
      this.swiperInstance.update();
    }
  }

  getOptions() {
    const optionsRaw = this.getAttribute('carousel-options');
    if (!optionsRaw) return { slidesPerView: 'auto', spaceBetween: 32 };

    try {
      return new Function('return ' + optionsRaw)();
    } catch (e) {
      return { slidesPerView: 'auto', spaceBetween: 32 };
    }
  }
}
customElements.define('product-swiper', ProductSwiper);

class PressCarousel extends Component {
  constructor() {
    super();
    this.quoteSwiper = null;
    this.logoSwiper = null;
  }

  connectedCallback() {
    this.style.opacity = '0';
    this.style.transition = 'opacity 0.4s ease-in-out';
    requestAnimationFrame(() => {
      this.prepareSlides('.pressCarousel__quotes');
      this.prepareSlides('.pressCarousel__logos');
      this.initSwipers();
    });
  }

  disconnectedCallback() {
    if (this.quoteSwiper) this.quoteSwiper.destroy();
    if (this.logoSwiper) this.logoSwiper.destroy();
  }

  prepareSlides(selector) {
    const TARGET_SLIDES = 15;
    const container = this.querySelector(selector);
    if (!container) return;

    const wrapper = container.querySelector('.swiper-wrapper');
    const slides = wrapper.querySelectorAll('.swiper-slide');

    if (slides.length > 0 && slides.length < TARGET_SLIDES) {
      const multiplier = Math.ceil(TARGET_SLIDES / slides.length);
      for (let i = 1; i < multiplier; i++) {
        slides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.classList.remove(
            'swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev',
            'swiper-slide-visible', 'swiper-slide-duplicate',
            'swiper-slide-duplicate-active', 'swiper-slide-duplicate-next',
            'swiper-slide-duplicate-prev'
          );
          wrapper.appendChild(clone);
        });
      }
    }
  }

  getOptions(element) {
    if (!element) return {};
    try {
      return JSON.parse(element.getAttribute('carousel-options') || '{}');
    } catch (e) {
      return {};
    }
  }

  initSwipers() {
    const quoteEl = this.querySelector('.pressCarousel__quotes');
    const logoEl = this.querySelector('.pressCarousel__logos');

    if (!quoteEl || !logoEl) {
      this.style.opacity = '1';
      return;
    }

    const quoteOptions = this.getOptions(quoteEl);
    const logoOptions = this.getOptions(logoEl);
    const onInit = () => {
      this.style.opacity = '1';
    };
    logoOptions.on = { init: onInit };

    whenSwiperReady((Swiper) => {
      if (this.logoSwiper) return;
      this.logoSwiper = new Swiper(logoEl, logoOptions);
      this.quoteSwiper = new Swiper(quoteEl, quoteOptions);

    if (this.logoSwiper && this.quoteSwiper) {
      this.logoSwiper.on('slideChange', () => {
        const activeIndex = this.logoSwiper.realIndex;
        this.quoteSwiper.slideToLoop(activeIndex, logoOptions.speed || 600);
      });
    }
    });
  }
}
customElements.define('press-carousel', PressCarousel);

class StickyCollection extends Component {
  constructor() {
    super();
    this.swiperInstance = null;
    this.mediaQuery = null;
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.style.opacity = '0';
    this.style.transition = 'opacity 0.4s ease-in-out';
    requestAnimationFrame(() => {
      this.init();
    });
  }

  disconnectedCallback() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.handleChange);
    }
    this.destroySwiper();
  }

  init() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) {
      this.style.opacity = '1';
      return;
    }
    this.options = this.getJsonAttribute(swiperEl, 'carousel-options');
    this.responsiveConfig = this.getJsonAttribute(swiperEl, 'carousel-responsive');
    const breakpoint = '(min-width: 960px)';
    this.shouldDisableOnDesktop = this.responsiveConfig[breakpoint] === false;
    this.mediaQuery = window.matchMedia(breakpoint);
    this.handleChange(this.mediaQuery);
    requestAnimationFrame(() => {
      this.style.opacity = '1';
    });

    this.mediaQuery.addEventListener('change', this.handleChange);
  }

  handleChange(e) {
    const isDesktop = e.matches;
    if (isDesktop && this.shouldDisableOnDesktop) {
      this.destroySwiper();
    } else {
      this.initSwiper();
    }
  }

  initSwiper() {
    if (this.swiperInstance) return;

    const swiperEl = this.querySelector('.swiper');
    const paddingLeft = this.getPaddingLeft(swiperEl);
    let scrollbarEl = this.options.scrollbar?.el;
    if (typeof scrollbarEl === 'string' && !document.querySelector(scrollbarEl)) {
      scrollbarEl = this.querySelector('.swiper-scroll__scrollbar');
    }

    whenSwiperReady((Swiper) => {
      if (this.swiperInstance) return;
      this.swiperInstance = new Swiper(swiperEl, {
        ...this.options,
        slidesOffsetBefore: paddingLeft,
        slidesOffsetAfter: paddingLeft,
        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          hide: false
        },
        on: {
          resize: () => {
            const newPadding = this.getPaddingLeft(swiperEl);
            if (this.swiperInstance) {
              this.swiperInstance.params.slidesOffsetBefore = newPadding;
              this.swiperInstance.params.slidesOffsetAfter = newPadding;
              this.swiperInstance.update();
            }
          }
        }
      });
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
      const wrapper = this.querySelector('.swiper-wrapper');
      if (wrapper) wrapper.removeAttribute('style');
      this.querySelectorAll('.swiper-slide').forEach(slide => slide.removeAttribute('style'));
    }
  }

  getPaddingLeft(swiperEl) {
    const alignSelector = swiperEl.getAttribute('carousel-offset-with');
    if (!alignSelector) return 0;

    const alignElement = document.querySelector(alignSelector);
    if (alignElement) {
      const rect = alignElement.getBoundingClientRect();
      return rect.left > 0 ? rect.left : 0;
    }
    return 0;
  }

  getJsonAttribute(element, attr) {
    try {
      return JSON.parse(element.getAttribute(attr) || '{}');
    } catch (e) {
      return {};
    }
  }
}
customElements.define('sticky-collection', StickyCollection);

class UpsellSlider extends Component {
  constructor() {
    super();
    this.swiperInstance = null;
  }
  connectedCallback() {
    this.initSwiper();
  }
  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
  }
  initSwiper() {
    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) return;
    let options = this.getOptions();
    const finalConfig = {
      ...options,
      observer: true,
      observeParents: true,
      width: 200,
      navigation: {
        nextEl: this.querySelector('.swiper-nav--next'),
        prevEl: this.querySelector('.swiper-nav--prev'),
      },
    };
    whenSwiperReady((Swiper) => {
      if (this.swiperInstance) return;
      this.swiperInstance = new Swiper(swiperContainer, finalConfig);
    });
  }

  getOptions() {
    const optionsRaw = this.getAttribute('carousel-options');
    if (!optionsRaw) return { slidesPerView: 'auto', spaceBetween: 16 };

    try {
      return new Function('return ' + optionsRaw)();
    } catch (e) {
      return { slidesPerView: 'auto', spaceBetween: 16 };
    }
  }
}
customElements.define('upsell-slider', UpsellSlider);

class CarouselSlider extends Component {
  constructor() {
    super();
    this.swiperInstance = null;
    this.mediaQuery = window.matchMedia('(min-width: 60em)');
  }
  connectedCallback() {
    this.init();
    this.mediaQuery.addEventListener('change', () => this.init());
  }

  parseAttribute(attrName) {
    const rawData = this.getAttribute(attrName);
    if (!rawData) return {};
    try {
      return JSON.parse(rawData.replace(/&quot;/g, '"').trim());
    } catch (e) {
      console.warn(`CarouselSlider: Could not parse ${attrName}`, e);
      return {};
    }
  }

  init() {
    const options = this.parseAttribute('carousel-options');
    const responsive = this.parseAttribute('carousel-responsive');

    const shouldDisable = this.mediaQuery.matches && responsive['(min-width: 60em)'] === false;

    if (shouldDisable) {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      return;
    }

    if (!this.swiperInstance) {
      whenSwiperReady((Swiper) => {
        if (!this.swiperInstance) {
          this.swiperInstance = new Swiper(this, options);
        }
      });
    }
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
  }
}
customElements.define('carousel-slider', CarouselSlider);

document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.value-propositions__container.swiper');
  if (!carousels.length) return;

  whenSwiperReady(() => {
  carousels.forEach(carousel => {
    const optionsAttr = carousel.getAttribute('carousel-options');
    const responsiveAttr = carousel.getAttribute('carousel-responsive');
    
    let options = optionsAttr ? JSON.parse(optionsAttr) : {};
    let responsive = responsiveAttr ? JSON.parse(responsiveAttr) : {};
    
    let swiperInstance = null;

    function initOrDestroySwiper() {
      const isDesktop = window.matchMedia("(min-width: 60em)").matches;
      const shouldDisableOnDesktop = responsive["(min-width: 60em)"] === false;

      if (shouldDisableOnDesktop && isDesktop) {
        if (carousel.swiper) {
          carousel.swiper.destroy(true, true);
          return;
        }
      } else {
        if (!carousel.classList.contains('swiper-initialized')) {
          new Swiper(carousel, {
            ...options,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          });
        }
      }
    }
    initOrDestroySwiper();
    window.addEventListener('resize', initOrDestroySwiper);
  });
  });
});